module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__lang__select-8c6777e59b33bb2dedfcd57f7ec888d7.svg";